export default __webpack_public_path__ + "static/media/StagSans-Medium.082a60dc.otf";